<template>
<section class="item-details-section">
    <div>
        <span class="text-semibold">Category: </span>
        <span>{{ deductionType.category_pretty }}</span>
    </div>

    <!-- Deferred comp shows the row even when unset, since a contribution type is
         expected to carry one. Insurance and retirement loan types carry designations
         too, so show theirs whenever one is set. -->
    <div v-if="deductionType.category == 'deferred-comp' || deductionType.designation">
        <span class="text-semibold">Designation: </span>
        <span>{{ deductionType.designation_pretty || '-' }}</span>
    </div>

    <div>
        <span class="text-semibold">For Primary Benefit of Employer: </span>
        <span>{{ deductionType.for_primary_benefit_of_employer ? 'Yes' : 'No' }}</span>
    </div>

    <div>
        <span class="text-semibold">Symmetry Benefit Type: </span>
        <span>{{ deductionType.symmetry_benefit_type_pretty || '-' }}</span>
    </div>

    <div>
        <span class="text-semibold">W2 Box: </span>
        <span>{{ deductionType.w2_box != null ? `Box ${deductionType.w2_box}` : '-' }}</span>
    </div>

    <div>
        <span class="text-semibold">W2 Code: </span>
        <span>{{ deductionType.w2_code || '-' }}</span>
    </div>

    <div>
        <span class="text-semibold">Annual Contribution Limit: </span>
        <span>{{ deductionType.annual_contribution_limit != null ? `$${deductionType.annual_contribution_limit}` : 'No limit' }}</span>
    </div>

    <div>
        <span class="text-semibold">Allow Multiple Per Company: </span>
        <span>{{ deductionType.allow_multiple_per_company ? 'Yes' : 'No' }}</span>
    </div>

    <div>
        <span class="text-semibold">Fields to Customize: </span>
        <span>{{ deductionType.fields_to_customize && deductionType.fields_to_customize.length ? deductionType.fields_to_customize.join(', ') : '-' }}</span>
    </div>

    <div v-if="deductionType.is_catchup">
        <span class="text-semibold">Annual Super Catch-Up Contribution Limit: </span>
        <span v-if="deductionType.annual_super_catchup_contribution_limit != null">
            ${{ deductionType.annual_super_catchup_contribution_limit }} (ages 60&ndash;63)
        </span>
        <span v-else>Not set &mdash; ages 60&ndash;63 use the limit above</span>
    </div>
</section>
</template>

<script>
export default {
    props: ['deductionType', ],
}
</script>
